(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hrny-ampl-landing"]) return;
  try {
    
const filmMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const setupFilm = (root) => root.querySelectorAll('.hrny-film-hero').forEach((hero) => {
  if (hero.dataset.filmReady) return;
  const canvas = hero.querySelector('canvas');
  const ctx = canvas.getContext('2d', { alpha: false });
  if (!ctx) return;
  hero.dataset.filmReady = 'fine-vhs';
  const patterns = Array.from({ length: 8 }, () => {
    const tile = document.createElement('canvas');
    tile.width = tile.height = 256;
    const tileCtx = tile.getContext('2d', { alpha: false });
    const pixels = tileCtx.createImageData(256, 256);
    for (let i = 0; i < pixels.data.length; i += 4) {
      const value = 48 + Math.random() * 160;
      pixels.data[i] = pixels.data[i + 1] = pixels.data[i + 2] = value;
      pixels.data[i + 3] = 255;
    }
    tileCtx.putImageData(pixels, 0, 0);
    return ctx.createPattern(tile, 'repeat');
  });
  let timer = null;
  let visible = false;
  let frame = 0;
  let scale = 1;
  const paint = () => {
    const x = Math.floor(Math.random() * 256);
    const y = Math.floor(Math.random() * 256);
    ctx.save();
    ctx.translate(-x, -y);
    ctx.fillStyle = patterns[frame++ % patterns.length];
    ctx.fillRect(x, y, canvas.width, canvas.height);
    ctx.restore();
    if (Math.random() < .35) {
      ctx.fillStyle = Math.random() > .5 ? '#eee' : '#111';
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.ellipse(Math.random() * canvas.width, Math.random() * canvas.height, (.5 + Math.random()) * scale, (.4 + Math.random()) * scale, Math.random() * 3, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  };
  const resize = () => {
    const bounds = hero.getBoundingClientRect();
    scale = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.max(1, Math.round(bounds.width * scale));
    canvas.height = Math.max(1, Math.round(bounds.height * scale));
    if (!filmMotion.matches) paint();
  };
  const sync = () => {
    const active = visible && !document.hidden && !filmMotion.matches;
    hero.classList.toggle('is-in-view', active);
    if (timer !== null) window.clearInterval(timer);
    timer = active ? window.setInterval(paint, 83) : null;
    if (active) paint();
  };
  const observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; sync(); });
  const resizeObserver = new ResizeObserver(resize);
  resize();
  observer.observe(hero);
  resizeObserver.observe(hero);
  document.addEventListener('visibilitychange', sync);
  filmMotion.addEventListener('change', sync);
  const unload = (event) => {
    if (!event.target.contains(hero)) return;
    observer.disconnect();
    resizeObserver.disconnect();
    if (timer !== null) window.clearInterval(timer);
    document.removeEventListener('visibilitychange', sync);
    filmMotion.removeEventListener('change', sync);
    document.removeEventListener('shopify:section:unload', unload);
  };
  document.addEventListener('shopify:section:unload', unload);
});
setupFilm(document);
document.addEventListener('shopify:section:load', (event) => setupFilm(event.target));

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-hrny-size-chart]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.hrnySizeChart);
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.matches('.hrny-size-chart-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });

{
  const setupGalleryAlignment = (root) => root.querySelectorAll('.hrny-ampl-body').forEach((body) => {
    const buy = body.querySelector('.hrny-buy');
    const button = body.querySelector('.hrny-submit');
    const copy = body.querySelector('.hrny-copy');
    if (!buy || !button || !copy || body.dataset.galleryAlignment) return;
    body.dataset.galleryAlignment = 'true';
    const align = () => {
      const offset = window.matchMedia('(min-width: 701px)').matches
        ? button.getBoundingClientRect().top - copy.getBoundingClientRect().top : 0;
      body.style.setProperty('--hrny-gallery-offset', `${offset}px`);
    };
    const observer = new ResizeObserver(align);
    observer.observe(buy);
    window.addEventListener('resize', align);
    align();
    const unload = (event) => {
      if (!event.target.contains(body)) return;
      observer.disconnect();
      window.removeEventListener('resize', align);
      document.removeEventListener('shopify:section:unload', unload);
      delete body.dataset.galleryAlignment;
    };
    document.addEventListener('shopify:section:unload', unload);
  });
  setupGalleryAlignment(document);
  document.addEventListener('shopify:section:load', (event) => setupGalleryAlignment(event.target));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hrny-tee-landing"]) return;
  try {
    
  // Pause the decorative effect when its photo is outside the viewport.
  if ('IntersectionObserver' in window) {
    const glitchObserver = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => target.classList.toggle('is-in-view', isIntersecting));
    });
    const observeHeroes = (root) => root.querySelectorAll('.hrny-hero').forEach((hero) => glitchObserver.observe(hero));
    observeHeroes(document);
    document.addEventListener('shopify:section:load', (event) => observeHeroes(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.hrny-hero').forEach((hero) => glitchObserver.unobserve(hero));
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-hrny-size-chart]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.hrnySizeChart);
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.matches('.hrny-size-chart-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });

{
  const setupGalleryAlignment = (root) => root.querySelectorAll('.hrny-product-body--editorial').forEach((body) => {
    const buy = body.querySelector('.hrny-buy');
    const button = body.querySelector('.hrny-submit');
    const copy = body.querySelector('.hrny-copy');
    if (!buy || !button || !copy || body.dataset.galleryAlignment) return;
    body.dataset.galleryAlignment = 'true';
    const align = () => {
      const offset = window.matchMedia('(min-width: 701px)').matches
        ? button.getBoundingClientRect().top - copy.getBoundingClientRect().top : 0;
      body.style.setProperty('--hrny-gallery-offset', `${offset}px`);
    };
    const observer = new ResizeObserver(align);
    observer.observe(buy);
    window.addEventListener('resize', align);
    align();
    const unload = (event) => {
      if (!event.target.contains(body)) return;
      observer.disconnect();
      window.removeEventListener('resize', align);
      document.removeEventListener('shopify:section:unload', unload);
      delete body.dataset.galleryAlignment;
    };
    document.addEventListener('shopify:section:unload', unload);
  });
  setupGalleryAlignment(document);
  document.addEventListener('shopify:section:load', (event) => setupGalleryAlignment(event.target));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
